import React from "react";
import InfoCard from "src/components/InfoCard";
import Layout from "src/components/Layout";

const ShoulderMeasurement: React.FC = () => {
  return (
    <Layout>
      <InfoCard title={"Shoulder Measurement Certificate"}>
        <ul
          style={{
            color: "#000866",
            marginLeft: "20px",
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          <p>
            On January 2015, industry safety group Step Change in Safety
            announced the measurement strategy for helicopter passengers
            travelling to and from offshore installations.
          </p>
          <p>
            Helicopter passengers are measured by specially-trained medics
            either on offshore installations or at onshore medical providers.
          </p>
        </ul>
      </InfoCard>
    </Layout>
  );
};

export default ShoulderMeasurement;
